import p1 from "../assets/images/number-1.png";
import p2 from "../assets/images/number-2.png";
import p3 from "../assets/images/number-3.png";
import p4 from "../assets/images/number-4.png";
import p5 from "../assets/images/number-5.png";
import p6 from "../assets/images/number-6.png";

import React, { useEffect, useState } from "react";

export default function Steps() {
  const [activeStage, setActiveStage] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".stage");
      let currentStage = 0;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2) {
          currentStage = index;
        }
      });

      setActiveStage(currentStage);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const stages = [
    { id: 1, description: "Know us", image: p1 },
    { id: 2, description: "Contact us", image: p2 },
    { id: 3, description: "Describe your queries", image: p3 },
    { id: 4, description: "Book an appointment or know your products", image: p4 },
    { id: 5, description: "Confirm your purchase", image: p5 },
    { id: 6, description: "Review us for future growth", image: p6 },
  ];

  return (
    <div className="bg-primary">
      {/* Title */}
      <h1 className="Rubik-Bold text-black text-center text-4xl py-10">
        Six Steps to a Hassle-Free Experience
      </h1>

      <div className="relative flex flex-col items-center py-10 bg-primary px-5">
        {/* Vertical Line */}
        <div className="absolute top-0 left-1/2 w-[5px] bg-gray-400 h-full hidden lg:block">
          <div
            className="bg-black"
            style={{
              height: `${(activeStage / (stages.length - 1)) * 100}%`,
              transition: "height 0.3s ease",
            }}
          ></div>
        </div>

        {/* Stages */}
        <div className="flex flex-col gap-16 w-full max-w-5xl px-5">
          {stages.map((stage, index) => (
            <div
              key={stage.id}
              className={`stage flex items-center ${
                index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
              } flex-col text-center lg:text-left`}
            >
              {/* Image */}
              <div
                className={`w-full lg:w-1/2 flex justify-center lg:justify-${
                  index % 2 === 0 ? "start" : "end"
                } px-5 mb-4 lg:mb-0`}
              >
                
              </div>

              {/* Description */}
              <div
                className={`w-full lg:w-1/2 flex flex-col  items-center lg:items-${
                  index % 2 === 0 ? "start" : "end"
                }`}
              >
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center transition-all duration-300 ${
                    activeStage === index ? "bg-black" : "bg-gray-300"
                  } mb-2`}
                >
                  <img
                    src={stage.image}
                    alt="best optical store"
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <p
                  className={`Rubik-Bold text-2xl px-4 ${
                    activeStage === index ? "text-black" : "text-gray-500"
                  }`}
                >
                  {stage.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
